import type { FC, ReactNode } from 'react'

import Reveal from '@/components/generals/reveal'

const FACTS: Array<{ value: string; label: string }> = [
    { value: '5', label: 'steps, every one by hand or by water' },
    { value: '40', label: 'strikes a minute from the water hammer' },
    { value: '10', label: 'minutes of stone polishing for each sheet' }
]

const Meaning: FC = (): ReactNode => {
    return (
        <section id='meaning' aria-label='What qogoz means' className='container-page py-16 md:py-28'>
            <div className='grid gap-10 lg:grid-cols-12 lg:gap-8'>
                <Reveal className='lg:col-span-3'>
                    <p className='font-heading text-[1.6rem] leading-none text-bark'>
                        qog&lsquo;oz
                    </p>
                    <p className='mt-3 text-sm text-bark-soft'>
                        noun, Uzbek
                    </p>
                    <p className='mt-1 text-sm text-bark-soft'>
                        1. paper. 2. a sheet to write on.
                    </p>
                </Reveal>

                <Reveal delay={150} className='lg:col-span-8 lg:col-start-5'>
                    <p className='font-heading text-[clamp(1.6rem,3.1vw,2.7rem)] font-light leading-[1.22] tracking-[-0.01em] text-bark'>
                        For eleven centuries in Samarkand the word meant something very particular:{' '}
                        a sheet of mulberry bark, beaten by a water wheel and polished with a stone until ink glides across it and never bleeds. We still make it that way, a few hundred sheets a week.
                    </p>

                    <dl className='mt-14 grid gap-8 border-t border-bark/15 pt-8 sm:grid-cols-3'>
                        {FACTS.map(fact => (
                            <div key={fact.label}>
                                <dt className='sr-only'>{fact.label}</dt>
                                <dd>
                                    <span className='block font-heading text-[2.8rem] font-light leading-none text-pomegranate'>
                                        {fact.value}
                                    </span>
                                    <span aria-hidden='true' className='mt-3 block max-w-[14rem] text-sm leading-relaxed text-bark-soft'>
                                        {fact.label}
                                    </span>
                                </dd>
                            </div>
                        ))}
                    </dl>
                </Reveal>
            </div>
        </section>
    )
}

export default Meaning
